import axios from "axios";
const API = import.meta.env.VITE_API_URL || "http://localhost:3001";
const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});
export const rewardsApi = {
  get: async <T>(path: string, admin = false) =>
    (
      await axios.get<T>(
        `${API}/${admin ? "admin/weekly-raffle/rewards" : "rewards"}${path}`,
        auth(),
      )
    ).data,
  post: async <T>(path: string, body: unknown, admin = false) =>
    (
      await axios.post<T>(
        `${API}/${admin ? "admin/weekly-raffle/rewards" : "rewards"}${path}`,
        body,
        auth(),
      )
    ).data,
  config: async (body: unknown) =>
    axios.put(`${API}/admin/weekly-raffle/rewards/case`, body, auth()),
};
export interface RewardItem {
  id: string;
  kind: "case" | "shop";
  title: string;
  imageUrl: string;
  valueCents: number;
  chanceBps: number;
  points: number;
  active: boolean;
}
export interface StashItem {
  id: string;
  title: string;
  imageUrl: string | null;
  valueCents: number | null;
  status: string;
  createdAt: string;
  source: string;
  userId: string;
  tradeOfferId?: string;
}
export interface Withdrawal {
  id: string;
  userId: string;
  steamId64: string;
  tradeUrl: string;
  status: string;
  totalCents: number;
  createdAt: string;
  tradeOfferId?: string;
  adminNote?: string;
  items?: StashItem[];
  itemSnapshot?: StashItem[];
}
export interface StashData {
  minimumCents: number;
  items: StashItem[];
  withdrawals: Withdrawal[];
}
export interface Opening {
  id: string;
  createdAt: string;
  result: {
    won: boolean;
    title: string;
    imageUrl: string | null;
    valueCents: number;
  };
}
export interface CaseStatus {
  oddsVersion: string;
  enabled: boolean;
  ready: boolean;
  openedToday: boolean;
  seconds: number;
  minimumSeconds: number;
  items: RewardItem[];
  missChanceBps: number;
  lastOpening: Opening | null;
}
export interface Catalog {
  items: RewardItem[];
  config: { enabled: boolean; minimumSeconds: number };
  shopEnabled: boolean;
}
export const euros = (n: number) =>
  new Intl.NumberFormat("en-IE", { style: "currency", currency: "EUR" }).format(
    n / 100,
  );
